
import { defineComponent,  reactive, ref,inject } from "vue";
import { useRouter } from "vue-router";
import { MenuMore } from "@/hooks/index";
import share from "@/components/share/share.vue";
export default defineComponent({
  components: {
    share,
  },
  props: {
    moreMenu: {
      //传递菜单的数据内容
      type: Array,
      detault: () => {
        return [];
      },
    },
    backgroundColor: {
      //背景色
      type: String,
      detault: "#fff",
    },
    fontColor: {
      //字体颜色
      type: String,
      detault: "#000",
    },
    skipPath: {
      //左侧跳转路径
      type:Function ||  String ,
      default: "/",
    },
    shareState: {
      //分享按钮是否显示
      type: Boolean,
      default: false,
    },
    menuState: {
      //菜单按钮是否显示
      type: Boolean,
      default: false,
    },
    title: {
      type: String, //标题,优先级比slot高
      default: "",
    },
    ios_app:{
      type:Boolean,
      
    }
  },
  setup(props: any) {
    console.log('props',props);
    
    const propsList: Array<MenuMore> = props.moreMenu as Array<MenuMore>;
    const router = useRouter(); //路由的信息和内置对象
    const menuShow = ref(false);
    const popupShow = ref(true);
    const $store: any = inject("$store");
    let is_app =ref(!$store.getIsApp())

  

    const menu: Array<MenuMore> = reactive([
      {
        icon: "wap-home-o",
        title: "Home",
        type: 0,
        url: "/",
      },
      {
        icon: "friends-o",
        title: "Account",
        type: 1,
        url: "/usercenter",
      },
      {
        icon: "shopping-cart-o",
        title: "shopping Cart",
        type: 2,
        url: "/cart",
      },
    ]);
    let showShare = ref(false)
    

    propsList
      ? propsList.forEach((element: MenuMore): void => {
          menu.push(element);
        })
      : "";
    //菜单路由跳转
    const jumpKip = (val: string): void => {
      menuShow.value = false;
      router.push(val);
    };
    //菜单显示
    const openMenu = (): void => {
      menuShow.value = !menuShow.value;
    };
    //点击关闭分享按钮
    const shareShow = (val: Boolean): void => {
      popupShow.value = false;
    };
    //返回按钮
    const boBack = (): void => {
      //1.判断是否函数
      if (
        Object.prototype.toString.call(props.skipPath) === "[object Function]"
      ) {
        props.skipPath();
      } else {
        //2.不传就是返回上一页
        if (props.skipPath == "/") {
           if(common.getStorage("isExLink")){
            // 如果返回上一页时  存在 isExLink 为true 则情况 kong_access_token 并情况 isExLink
              common.delStorage('kong_access_token')
              common.delStorage("isExLink")
           }
          router.back()
        } else if (props.skipPath.slice(0, 1) === "/") {
          //3.是否路由跳转
          router.push(props.skipPath);
        } else {
          window.location.href = props.skipPath;
        }
      }
    };
    //外层关闭
    document.addEventListener("click", (e: any) => {
      var currentCli = document.getElementById("menuName");
      if (currentCli) {
        if (!currentCli.contains(e.target)) {
          //点击到了id为sellineName以外的区域，隐藏下拉框
          menuShow.value = false;
        }
      }
    });
    //点击打开分享按钮
    const transmitPopup = (): void => {
      showShare.value = true;
    };
    return {
      menu,
      jumpKip,
      menuShow,
      openMenu,
      shareShow,
      popupShow,
      boBack,
      transmitPopup,
      showShare,
      is_app,
    };
  },
});
